
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import BarcodeIconLabel from '../components/BarcodeIconLabel.vue'
import { IBarcodeDefinitionType } from '@/utils/types'

@Options({
  components: { BarcodeIconLabel },
  emits: ['subLabel:click'],
})
export default class BarcodeInfoLabel extends Vue {
  @Prop({ type: Object }) readonly barcodeTypeInfo!: IBarcodeDefinitionType
  @Prop({ type: String }) readonly label!: string
  @Prop({ type: String }) readonly subLabel!: string

  redirectTo() {
    this.$emit('subLabel:click')
  }
}
